// Must run before player/player.js is evaluated: player.js reads
// globalThis.__CVS_HOST__ once at load (see "HOST:" in player.js) and imports
// this file first for that reason. web/app.js fills the hooks in before any
// player exists.
globalThis.__CVS_HOST__ = globalThis.__CVS_HOST__ || {};
